(function () {
  const DRAG_THRESHOLD = 5;

  function initDragScroll(scroller, options = {}) {
    if (!scroller || scroller.dataset.dragScrollInitialized === 'true') return;
    scroller.dataset.dragScrollInitialized = 'true';

    let startX = 0;
    let startScrollLeft = 0;
    let isPointerDown = false;
    let isDragging = false;

    const onPointerDown = (event) => {
      // Touch/pen rely on native scroll — never engage JS drag for them.
      if (event.pointerType !== 'mouse') return;
      if (event.button !== 0) return;
      if (event.target.closest('button, input, select, textarea')) return;

      isPointerDown = true;
      isDragging = false;
      startX = event.clientX;
      startScrollLeft = scroller.scrollLeft;
    };

    const onPointerMove = (event) => {
      if (!isPointerDown) return;
      if (event.pointerType !== 'mouse') return;
      const deltaX = event.clientX - startX;

      if (!isDragging && Math.abs(deltaX) > DRAG_THRESHOLD) {
        isDragging = true;
        scroller.classList.add('is-dragging');
        try {
          scroller.setPointerCapture?.(event.pointerId);
        } catch (e) {
          /* noop */
        }
      }

      if (isDragging) {
        if (options.stopPropagation) event.stopPropagation();
        event.preventDefault();
        scroller.scrollLeft = startScrollLeft - deltaX;
      }
    };

    const endPointer = (event) => {
      if (!isPointerDown) return;
      isPointerDown = false;
      if (scroller.hasPointerCapture?.(event.pointerId)) {
        try {
          scroller.releasePointerCapture(event.pointerId);
        } catch (e) {
          /* noop */
        }
      }
      requestAnimationFrame(() => {
        scroller.classList.remove('is-dragging');
        isDragging = false;
      });
    };

    scroller.addEventListener('pointerdown', onPointerDown);
    scroller.addEventListener('pointermove', onPointerMove);
    scroller.addEventListener('pointerup', endPointer);
    scroller.addEventListener('pointercancel', endPointer);
    scroller.addEventListener('pointerleave', endPointer);

    scroller.addEventListener(
      'click',
      (event) => {
        if (scroller.classList.contains('is-dragging') || isDragging) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    scroller.addEventListener('dragstart', (event) => event.preventDefault());
  }

  function setupDotsAndSync(container, track) {
    const dotsContainer = container.querySelector('[data-card-media-scroll-dots]');
    const slides = Array.from(track.querySelectorAll('.card-media-scroll__slide'));

    if (!dotsContainer) return;
    if (slides.length <= 1) {
      dotsContainer.innerHTML = '';
      return;
    }
    if (dotsContainer.dataset.dotsInitialized === 'true') return;
    dotsContainer.dataset.dotsInitialized = 'true';

    dotsContainer.innerHTML = '';
    slides.forEach((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'card-media-scroll__dot';
      dot.setAttribute('aria-label', `画像 ${index + 1} を表示`);
      dot.dataset.index = String(index);
      if (index === 0) dot.classList.add('is-active');
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const target = slides[index];
        if (!target) return;
        track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      });
      dotsContainer.appendChild(dot);
    });

    const dots = Array.from(dotsContainer.children);

    let frame = 0;
    const updateActive = () => {
      frame = 0;
      const width = track.clientWidth;
      if (!width) return;
      const idx = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / width)));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
    };

    track.addEventListener(
      'scroll',
      () => {
        if (frame) return;
        frame = requestAnimationFrame(updateActive);
      },
      { passive: true }
    );

    // Recalculate when card resizes (e.g. responsive grid changes)
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(updateActive);
      });
      ro.observe(track);
    }
  }

  function initCardMediaScroll(container) {
    const track = container.querySelector('.card-media-scroll__track');
    if (!track) return;
    initDragScroll(track, { stopPropagation: true });
    setupDotsAndSync(container, track);
  }

  function initAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-featured-collection-free-scroll]').forEach((list) => initDragScroll(list));
    scope.querySelectorAll('[data-card-media-scroll]').forEach((container) => initCardMediaScroll(container));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
